import React from 'react';

const Competitions: React.FC = () => {
  return (
    <div className="space-y-6 animate-fade-in">
      <div className="win-card p-6">
        <h1 className="text-3xl font-bold text-win-dark-text">Competitions</h1>
        <p className="text-win-dark-text-muted">Join trading competitions and compete with other traders</p>
      </div>
      {/* Competitions content will be implemented */}
    </div>
  );
};

export default Competitions;